import { render, staticRenderFns } from "./setting-account.html?vue&type=template&id=72d75ca8&scoped=true&"
import script from "./setting-account.js?vue&type=script&lang=js&"
export * from "./setting-account.js?vue&type=script&lang=js&"
import style0 from "./setting-account.scss?vue&type=style&index=0&id=72d75ca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d75ca8",
  null
  
)

export default component.exports